import { __extends } from "tslib";
import { TinyYolov2Options } from '../tinyYolov2';
var TinyFaceDetectorOptions = /** @class */ (function (_super) {
    __extends(TinyFaceDetectorOptions, _super);
    function TinyFaceDetectorOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._name = 'TinyFaceDetectorOptions';
        return _this;
    }
    return TinyFaceDetectorOptions;
}(TinyYolov2Options));
export { TinyFaceDetectorOptions };
//# sourceMappingURL=TinyFaceDetectorOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/tinyFaceDetector/TinyFaceDetectorOptions.js
// module id = 1177
// module chunks = 0